<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
        id="page-login"
        v-bind:style="background_image"
      >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 sm:m-0 m-4">
          <div class="mb-5" id="logo_image">
            <img :src="get_logo" :width="'200px'" />
          </div>
          <b-card class="mt-5">
            <div class="full-page-bg-color">
              <div class="vx-row">
                <div
                  class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg"
                >
                  <div class="p-8">
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">{{ $t("Recoveryourpassword") }}</h4>
                      <p>{{ $t("RecoveryourpasswordText") }}</p>
                    </div>
                    <form method="post" v-on:submit.prevent="checkForm">
                      <div class="w-full mb-5 mt-8">
                        <b-input-group>
                          <template #prepend>
                            <b-input-group-text>
                              <b-icon icon="person"></b-icon>
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            type="email"
                            v-validate="'required|email'"
                            v-model="email"
                            name="email"
                            :placeholder="$t('Email')"
                            @keydown.enter="submitForm"
                          />
                        </b-input-group>
                        <span
                          class="text-danger text-sm"
                          v-if="errors.has('email')"
                          >{{ errors.first("email") }}</span
                        >
                      </div>

                      <b-button
                        type="border"
                        variant="border"
                        to="/user/login"
                        class="px-4 w-full md:w-auto border-primary text-primary"
                        >{{ $t("BackToLogin") }}</b-button
                      >
                      <b-button
                        variant="primary"
                        class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                        type="filled"
                        @click.prevent="submitForm"
                        >{{ $t("RecoverPassword") }}</b-button
                      >
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { Validator } from "vee-validate";

export default {
  data() {
    return {
      email: "",
      logo: require("@/assets/images/logo/logo.png"),
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  computed: {
     get_logo() {
      return this.$store.getters.whitelabel.logo.path;
    },
    background_image(){
        return {'background-image' : "url("+this.$store.getters.whitelabel.background_image.path + ")"};
    }
 },
  watch: {
    background_image: function(newValue) {},
    get_logo: function(newValue) {},
    
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  created() {
    this.loadLocale(this.$i18n.locale);
  },
  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *  submitForm method for submiting form
     **/
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.userForgot();
        } else {
        }
      });
    },
    /**
     *  userForgot method for submiting form
     **/
    userForgot() {
      this.show = true;
      this.success = "";
      this.error = "";
      this.$store
        .dispatch("UserForgot", this.email)
        .then((res) => {
          this.show = false;
          this.success = this.$t("LinkSent");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          if (error.includes("status code 400")) {
            error = "Email not registered";
          }
          this.$log.error(
            "File : Add.vue | Function : userForgot() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>
